// import httpUtil from '../assets/script/utils/http'

import httpUtil from "../assets/script/utils/http";

const state = {
  info: null
};

const mutations = {
  MSet(state, info) {
    state.info = info
  }
};


const actions = {
  ALogin(ctx, params) {
    return httpUtil.post("/Account/login", params)
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
